/* global axios */
import ApiClient from './ApiClient';

class InboxMembers extends ApiClient {
  constructor() {
    super('inbox_members', { accountScoped: true });
  }

  update({ inboxId, agentList }) {
    return axios.patch(this.url, {
      inbox_id: inboxId,
      user_ids: agentList,
    });
  }

  // So os colaboradores DIRETOS (quem entrou via TIME fica fora — e
  // gerenciado pelo seletor de times da tela de colaboradores).
  getDirect(inboxId) {
    return axios.get(`${this.url}/${inboxId}`, {
      params: { direct: true },
    });
  }
}

export default new InboxMembers();
